import { useState, useMemo } from 'react';
import MainLayout from '../../../components/layout/MainLayout';
import SearchFilters from './components/SearchFilters';
import { mockAfterSalesOrders } from './mockData';
import type { AfterSalesOrder } from './types';

export default function AfterSalesPage() {
  const [orders] = useState<AfterSalesOrder[]>(mockAfterSalesOrders);
  const [filters, setFilters] = useState<any>({});

  const filteredOrders = useMemo(() => {
    return orders.filter(order => {
      if (filters.searchValue) {
        const value = filters.searchValue.toLowerCase();
        const field = filters.searchType;
        
        if (field === 'refundNo') {
          if (!order.refundNo.toLowerCase().includes(value) && !order.orderNo.toLowerCase().includes(value)) {
            return false;
          }
        } else if (field === 'productName') {
          if (!order.productName.toLowerCase().includes(value)) return false;
        } else if (field === 'operatorId') {
          if (order.operatorId.toLowerCase() !== value) return false;
        }
      }

      if (filters.status && order.status !== filters.status) return false;

      if (filters.refundTimeRange?.start && order.refundTime && order.refundTime < filters.refundTimeRange.start.replace('T', ' ')) return false;
      if (filters.refundTimeRange?.end && order.refundTime && order.refundTime > filters.refundTimeRange.end.replace('T', ' ')) return false;

      return true;
    });
  }, [orders, filters]);

  const getStatusColor = (status: string) => {
    return status === '退款成功' 
      ? 'text-green-600 bg-green-50' 
      : 'text-red-600 bg-red-50';
  };

  const handleExport = () => {
    alert('导出功能开发中...');
  };

  return (
    <MainLayout>
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-gray-900">售后订单</h1>
          <button
            onClick={handleExport}
            className="px-4 py-2 bg-teal-500 text-white rounded-lg text-sm hover:bg-teal-600 whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-download-line"></i>
            导出
          </button>
        </div>

        <SearchFilters onSearch={setFilters} />

        <div className="bg-white rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">售后单号</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">订单号</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">商品名称</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">商品单价/数量</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">退款金额</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">申请时间</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">退款时间</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">操作用户</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">操作用户ID</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">售后状态</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredOrders.map((order) => (
                  <tr key={order.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.refundNo}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.orderNo}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.productName}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">¥{order.productPrice.toFixed(2)} / {order.quantity}</td>
                    <td className="px-4 py-3 text-sm font-medium text-red-600 whitespace-nowrap">¥{order.refundAmount.toFixed(2)}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.applyTime}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.refundTime || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.operatorName}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">{order.operatorId}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(order.status)}`}>
                        {order.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredOrders.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-inbox-line text-4xl text-gray-300 mb-2"></i>
              <p className="text-sm text-gray-500">暂无售后订单数据</p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
}
